$mol_button_open $mol_button_minor
	sub /
		<= Icon $mol_icon_upload
		<= Native $mol_button_open_native
			files? <=> files_handled? <=> files? /File
			accept <= accept \
			multiple <= multiple true

$mol_button_open_native $mol_view
	dom_name \input
	files? /File
	attr *
		type \file
		accept <= accept \
		multiple <= multiple true
	event *
		change? <=> picked? null
